import * as React from "react";
import { forwardRef } from "react";
const SvgDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.408 1.5H6.563A5.07 5.07 0 0 0 1.5 6.563v4.875A5.07 5.07 0 0 0 6.563 16.5h4.875a5.07 5.07 0 0 0 5.062-5.062V6.563A5.07 5.07 0 0 0 11.408 1.5M6.323 12.173a.6.6 0 1 1-1.2 0V8.348a.6.6 0 1 1 1.2 0zm3.337 0a.6.6 0 0 1-1.2 0V5.835a.6.6 0 1 1 1.2 0zm3.158 0a.6.6 0 1 1-1.2 0V7.365a.6.6 0 1 1 1.2 0z", fill: "#2196F3" }));
const ForwardRef = forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
